import React, { useState } from 'react';

// Import all images statically
import CD002 from '../assets/CD002.jpeg';
import CD003 from '../assets/CD003.jpeg';
import CD004 from '../assets/CD004.jpeg';
import CD006 from '../assets/CD006.jpg';
import CD007 from '../assets/CD007.jpg';
import CD008 from '../assets/CD008.jpg';
import CD009 from '../assets/CD009.jpg';
import CD010 from '../assets/CD010.jpg';
import Bangalore001 from '../assets/Bangalore001.JPG';
import Bangalore002 from '../assets/Bangalore002.JPG';
import Bangalore003 from '../assets/Bangalore003.JPG';
import Bangalore004 from '../assets/Bangalore004.JPG';
import Bangalore005 from '../assets/Bangalore005.JPG';
import DSC_7063 from '../assets/DSC_7063.JPG';
import DSC_7087 from '../assets/DSC_7087.JPG';
import DSC_7223 from '../assets/DSC_7223.JPG';
import DSC_7232 from '../assets/DSC_7232.JPG';
import DSC_7254 from '../assets/DSC_7254.JPG';
import Pune001 from '../assets/Pune001.jpg';
import Pune002 from '../assets/Pune002.jpg';
import Pune003 from '../assets/Pune003.jpg';
import Pune004 from '../assets/Pune004.jpg';
import Pune005 from '../assets/Pune005.jpg';
import Pune006 from '../assets/Pune006.jpg';
import Pune007 from '../assets/Pune007.jpg';
import Pune008 from '../assets/Pune008.jpg';
import Mumbai001 from '../assets/Mumbai001.JPG';
import Mumbai002 from '../assets/Mumbai002.JPG';
import Mumbai003 from '../assets/Mumbai003.JPG';
import Mumbai004 from '../assets/Mumbai004.JPG';
import Mumbai005 from '../assets/Mumbai005.JPG';
import Mumbai006 from '../assets/Mumbai006.JPG';
import Mumbai007 from '../assets/Mumbai007.JPG';
import Mumbai008 from '../assets/Mumbai008.JPG';
import DSC_7446 from '../assets/DSC_7446.JPG';
import DSC_7451 from '../assets/DSC_7451.JPG';
import DSC_7463 from '../assets/DSC_7463.JPG';
import DSC_7473 from '../assets/DSC_7473.JPG';
import DSC_7482 from '../assets/DSC_7482.JPG';
import DSC_7503 from '../assets/DSC_7503.JPG';
import DSC_7572 from '../assets/DSC_7572.JPG';
import DSC_7618 from '../assets/DSC_7618.JPG';

// Organize images by city (constant - moved outside component for stable useMemo deps)
const cityImages = {
  hyderabad: [
    'CD004.jpeg',
    'CD003.jpeg',
    'CD006.jpg',
    'CD007.jpg',
    'CD008.jpg',
    'CD009.jpg',
    'CD010.jpg',
    'CD002.jpeg'
  ],
  bangalore: [
    'Bangalore001.JPG',
    'Bangalore002.JPG',
    'Bangalore003.JPG',
    'Bangalore004.JPG',
    'Bangalore005.JPG',
    'DSC_7063.JPG',
    'DSC_7087.JPG',
    'DSC_7223.JPG',
    'DSC_7232.JPG',
    'DSC_7254.JPG'
  ],
  pune: [
    'Pune001.jpg',
    'Pune002.jpg',
    'Pune003.jpg',
    'Pune004.jpg',
    'Pune005.jpg',
    'Pune006.jpg',
    'Pune007.jpg',
    'Pune008.jpg'
  ],
  mumbai: [
    'Mumbai001.JPG',
    'Mumbai002.JPG',
    'Mumbai003.JPG',
    'Mumbai004.JPG',
    'Mumbai005.JPG',
    'Mumbai006.JPG',
    'Mumbai007.JPG',
    'Mumbai008.JPG'
  ],
  delhi: [
    'DSC_7446.JPG',
    'DSC_7451.JPG',
    'DSC_7463.JPG',
    'DSC_7473.JPG',
    'DSC_7482.JPG',
    'DSC_7503.JPG',
    'DSC_7572.JPG',
    'DSC_7618.JPG'
  ]
};

const PreviousDialogues = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedCity, setSelectedCity] = useState('all');
  const [showAllPhotos, setShowAllPhotos] = useState(false);

  // Map image names to imported images
  const imageMap = {
    'CD002.jpeg': CD002,
    'CD003.jpeg': CD003,
    'CD004.jpeg': CD004,
    'CD006.jpg': CD006,
    'CD007.jpg': CD007,
    'CD008.jpg': CD008,
    'CD009.jpg': CD009,
    'CD010.jpg': CD010,
    'Bangalore001.JPG': Bangalore001,
    'Bangalore002.JPG': Bangalore002,
    'Bangalore003.JPG': Bangalore003,
    'Bangalore004.JPG': Bangalore004,
    'Bangalore005.JPG': Bangalore005,
    'DSC_7063.JPG': DSC_7063,
    'DSC_7087.JPG': DSC_7087,
    'DSC_7223.JPG': DSC_7223,
    'DSC_7232.JPG': DSC_7232,
    'DSC_7254.JPG': DSC_7254,
    'Pune001.jpg': Pune001,
    'Pune002.jpg': Pune002,
    'Pune003.jpg': Pune003,
    'Pune004.jpg': Pune004,
    'Pune005.jpg': Pune005,
    'Pune006.jpg': Pune006,
    'Pune007.jpg': Pune007,
    'Pune008.jpg': Pune008,
    'Mumbai001.JPG': Mumbai001,
    'Mumbai002.JPG': Mumbai002,
    'Mumbai003.JPG': Mumbai003,
    'Mumbai004.JPG': Mumbai004,
    'Mumbai005.JPG': Mumbai005,
    'Mumbai006.JPG': Mumbai006,
    'Mumbai007.JPG': Mumbai007,
    'Mumbai008.JPG': Mumbai008,
    'DSC_7446.JPG': DSC_7446,
    'DSC_7451.JPG': DSC_7451,
    'DSC_7463.JPG': DSC_7463,
    'DSC_7473.JPG': DSC_7473,
    'DSC_7482.JPG': DSC_7482,
    'DSC_7503.JPG': DSC_7503,
    'DSC_7572.JPG': DSC_7572,
    'DSC_7618.JPG': DSC_7618,
  };

  // Get all images or filter by selected city
  // For "all", interleave photos from different cities for better distribution
  const allImages = React.useMemo(() => {
    if (selectedCity === 'all') {
      const mixedImages = [];
      const maxLength = Math.max(
        cityImages.hyderabad.length,
        cityImages.bangalore.length,
        cityImages.pune.length,
        cityImages.mumbai.length,
        cityImages.delhi.length
      );
      
      // Interleave photos from each city
      for (let i = 0; i < maxLength; i++) {
        if (i < cityImages.hyderabad.length) mixedImages.push(cityImages.hyderabad[i]);
        if (i < cityImages.bangalore.length) mixedImages.push(cityImages.bangalore[i]);
        if (i < cityImages.pune.length) mixedImages.push(cityImages.pune[i]);
        if (i < cityImages.mumbai.length) mixedImages.push(cityImages.mumbai[i]);
        if (i < cityImages.delhi.length) mixedImages.push(cityImages.delhi[i]);
      }
      
      return mixedImages;
    }
    return cityImages[selectedCity] || [];
  }, [selectedCity]);

  // Show only 12 photos initially when "all" is selected, or all photos for specific cities
  const images = React.useMemo(() => {
    if (selectedCity === 'all' && !showAllPhotos) {
      return allImages.slice(0, 12);
    }
    return allImages;
  }, [allImages, selectedCity, showAllPhotos]);

  // Reset showAllPhotos when city filter changes
  React.useEffect(() => {
    setShowAllPhotos(false);
  }, [selectedCity]);

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  // Reset image index when filter changes
  React.useEffect(() => {
    setCurrentImageIndex(0);
  }, [selectedCity]);

  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowRight') nextImage(e);
      else if (e.key === 'ArrowLeft') prevImage(e);
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lightboxOpen]);

  const getCityLabel = (city) => {
    const labels = {
      hyderabad: 'Hyderabad',
      bangalore: 'Bangalore',
      pune: 'Pune',
      mumbai: 'Mumbai',
      delhi: 'Delhi',
      all: 'All Chapters'
    };
    return labels[city] || city;
  };

  return (
    <>
      <section className="py-[100px] bg-[#F5F5F0] opacity-0 animate-fadeIn-delayed-3">
        <div className="w-[90%] max-w-[1200px] mx-auto px-5">
          <h2 className="font-heading font-semibold text-[2rem] relative pb-[15px] mb-8 text-[#333333] text-center">
            Previous Dialogues: Culture in the Age of AI
          </h2>
          
          {/* City Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {['all', 'hyderabad', 'bangalore', 'pune', 'mumbai', 'delhi'].map((city) => {
              return (
                <button
                  key={city}
                  onClick={() => setSelectedCity(city)}
                  className={`px-6 py-2 rounded-full font-heading font-semibold text-sm uppercase tracking-wide transition-all duration-300 ${
                    selectedCity === city
                      ? 'bg-gradient-to-br from-[#6B4DC4] to-[#4ECDC4] text-white shadow-[0_4px_15px_rgba(107,77,196,0.4)]'
                      : 'bg-white text-[#6B4DC4] border-2 border-[#6B4DC4] hover:bg-[#6B4DC4] hover:text-white'
                  }`}
                >
                  {getCityLabel(city)}
                </button>
              );
            })}
          </div>

          {images.length > 0 ? (
            <>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-[25px] mt-[50px]">
                {images.map((img, index) => {
                  const imageSrc = imageMap[img];
                  if (!imageSrc) {
                    console.warn(`Image not found in map: ${img}`);
                    return null;
                  }
                  return (
                    <div 
                      key={`${selectedCity}-${img}-${index}`}
                      className="relative overflow-hidden rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.1)] aspect-[4/3] cursor-pointer transition-all duration-300 hover:scale-[1.05]"
                      onClick={() => openLightbox(index)}
                    >
                      <img 
                        src={imageSrc} 
                        alt={`Culture Dialogue ${selectedCity} Event ${index + 1}`}
                        className="w-full h-full object-cover transition-all duration-300"
                      />
                    </div>
                  );
                })}
              </div>
              
              {/* View More link - only show when "all" is selected and there are more than 12 photos */}
              {selectedCity === 'all' && allImages.length > 12 && !showAllPhotos && (
                <div className="text-center mt-8">
                  <button
                    onClick={() => setShowAllPhotos(true)}
                    className="text-[#6B4DC4] font-body text-sm underline hover:text-[#4ECDC4] transition-colors duration-300"
                  >
                    View More
                  </button>
                </div>
              )}
            </>
          ) : (
            <p className="text-center text-[#666666] mt-8">No images available for this chapter.</p>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {lightboxOpen && images[currentImageIndex] && (
        <div 
          className="fixed top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.95)] flex items-center justify-center z-[9999] opacity-100 visible transition-[opacity_0.3s_ease,visibility_0.3s_ease]"
          onClick={closeLightbox}
        >
          <span 
            className="absolute top-[30px] right-[40px] text-[50px] text-white cursor-pointer font-light z-[10000] select-none leading-none transition-all duration-300 hover:text-[#4ECDC4] hover:rotate-90"
            onClick={closeLightbox}
          >
            &times;
          </span>
          {imageMap[images[currentImageIndex]] && (
            <img 
              src={imageMap[images[currentImageIndex]]} 
              alt="Lightbox" 
              className="max-w-[90%] max-h-[90vh] object-contain rounded-lg shadow-[0_10px_50px_rgba(0,0,0,0.5)]"
              onClick={(e) => e.stopPropagation()}
            />
          )}
          <div className="absolute w-full flex justify-between px-5 pointer-events-none">
            <button 
              className="bg-[rgba(107,77,196,0.8)] text-white border-none text-[30px] py-[15px] px-5 cursor-pointer rounded transition-all duration-300 pointer-events-auto select-none hover:bg-[#6B4DC4] hover:scale-110"
              onClick={prevImage}
            >
              &#10094;
            </button>
            <button 
              className="bg-[rgba(107,77,196,0.8)] text-white border-none text-[30px] py-[15px] px-5 cursor-pointer rounded transition-all duration-300 pointer-events-auto select-none hover:bg-[#6B4DC4] hover:scale-110"
              onClick={nextImage}
            >
              &#10095;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviousDialogues;
